/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const channelRowSchema = z.object({
  channel: z.string(),
  sessions: z.number(),
  installIntents: z.number(),
  conversionRate: z.number(),
});

const landingRowSchema = z.object({
  template: z.string(),
  sessions: z.number(),
  installIntents: z.number(),
});

const funnelStepSchema = z.object({
  step: z.string(),
  count: z.number(),
});

export const getGa4DashboardV1ResponseDataSchema = z.object({
  configured: z.boolean(),
  error: z.string().nullable().optional(),
  period: z.enum(['7d', '30d', 'all']),
  realtimeActiveUsers: z.number(),
  channels: z.array(channelRowSchema),
  landingTemplates: z.array(landingRowSchema),
  funnel: z.array(funnelStepSchema),
});

export type IGetGa4DashboardV1ResponseData = z.infer<typeof getGa4DashboardV1ResponseDataSchema>;

export const getGa4DashboardV1ResponseSchema = createApiResponseSchema(
  getGa4DashboardV1ResponseDataSchema,
) as z.ZodSchema<IAPI<IGetGa4DashboardV1ResponseData>>;

export type IGetGa4DashboardV1Response = IAPI<IGetGa4DashboardV1ResponseData>;
